import React, { useState, useEffect } from "react";
import tw from "twin.macro";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import { useLocation, useNavigate } from "react-router-dom";
import { ECommerce } from 'api/AppConfigApi';
import toast, { Toaster } from "react-hot-toast";
import { reactLocalStorage } from "reactjs-localstorage";
import { getProduct } from "api/ProductApi";
import RemoveCart from "components/RemoveCart";
import { filterFormatToDate } from "utility/Constant";
import { getCustomerId } from "utility/HeaderConfig";
import { useCartContext } from "context/UseCartContext";
import { getAddToCart, getBranchId } from "utility/HeaderConfig";
import Noimg from "../images/no_img.jpg";

const StyledDiv = tw.div`font-display overflow-hidden`;

export default ({ configImages }) => {
  const [verifyAmount, setVerifyAmount] = useState(0);
  const [validation, setValidation] = useState(true);
  const [viewCart, setViewCart] = useState([]);
  const [total, setTotal] = useState([]);
  const [showModal, setShowModal] = useState("");
  const [banner, setBanner] = useState([]);
  const history = useNavigate();
  const location = useLocation();
  const myparam = location.state.viewCart;
  const { dispatch, data } = useCartContext();

  useEffect(() => {
    if (myparam) {
      // setViewCart(history?.location?.state?.propValueData)
    } else {
      viewCartList();
      getBanner();
    }
    //eslint-disable-next-line
  }, [data]);

  useEffect(() => {
    if (myparam) {
      setViewCart(myparam);
      calcTotal(myparam);
    } else {
      viewCartList();
    }
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    getBanner();
    getPriceCheck();
    // viewCartList();
    //eslint-disable-next-line
  }, []);

  const calcTotal = (cartList) => {
    setValidation(true);
    let totalCartValue = 0;
    cartList &&
      cartList.forEach((data) => {
        if (data.total > 0) {
          totalCartValue += data.total;
        }
      });
    const isSoldProductAvailable =
      cartList.length > 0 &&
      cartList.some((data) => data.statusName?.toLowerCase() === "sold");
    if (isSoldProductAvailable) setValidation(false);
    setTotal(totalCartValue);
  };

  const getBanner = () => {
    configImages &&
      configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "cart") {
          setBanner(data.value);
        }
      });
  };

  const viewCartList = () => {
    let dataList = [];
    let basePrice = 0;
    let total = 0;
    let cgst = 0;
    let sgst = 0;
    const newArray =
      getAddToCart() &&
      JSON.parse(getAddToCart()).filter(
        (cartItem) => cartItem.branch === getBranchId()
      );
    if (newArray?.length > 0) {
      newArray &&
        newArray.forEach((element, index) => {
          let filter = {
            branch: getBranchId(),
            id: element.id,
            beforeCreatedAt: filterFormatToDate(moment().format("YYYY-MM-DD")),
          };
          const respData = getProduct(10, filter);
          respData.then((res) => {
            dataList.push(res.response.content[0]);
            newArray &&
              newArray.forEach((element, index) => {
                if (dataList.length - 1 === index) {
                  if (dataList[index].basePrice) {
                    basePrice += Number(dataList[index].basePrice);
                  }
                  if (dataList[index].total) {
                    total += Number(dataList[index].total);
                  }
                  if (dataList[index].saleTaxList[1].amount) {
                    cgst += Number(dataList[index].saleTaxList[1].amount);
                  }
                  if (dataList[index].saleTaxList[0].amount) {
                    sgst += Number(dataList[index].saleTaxList[0].amount);
                  }
                  let totalAmount = 0;
                  if (dataList.length > 0) {
                    totalAmount = dataList.reduce((result, item) => {
                      return (result += parseFloat(Math.trunc(item.total)));
                    }, 0);
                  }
                  setTotal(totalAmount);
                  setViewCart(dataList);
                }
              });
          });
        });
    }
  };

  const removeItemFromCart = (code) => {
    let productData = JSON.parse(getAddToCart());
    const result = productData.filter((item) => item.productCode !== code);
    if (result) {
      reactLocalStorage.set("CartList", JSON.stringify(result));
      dispatch({ type: "ADD", payload: result });
      setViewCart(result);
      let dataList = [];
      let basePrice = 0;
      let total = 0;
      let cgst = 0;
      let sgst = 0;
      result &&
        result.forEach((element, index) => {
          dataList.push(element);
          if (dataList[index].basePrice) {
            basePrice += Number(
              dataList[index].basePrice +
              dataList[index].gemTotal +
              dataList[index].diamondTotal
            );
          }
          if (dataList[index].total) {
            total += Number(dataList[index].total);
          }
          if (dataList[index].saleTaxList[1].amount) {
            cgst += Number(dataList[index].saleTaxList[1].amount);
          }
          if (dataList[index].saleTaxList[0].amount) {
            sgst += Number(dataList[index].saleTaxList[0].amount);
          }
          let totalAmount = 0;
          if (dataList.length > 0) {
            totalAmount = dataList.reduce((result, item) => {
              return (result += parseFloat(Math.trunc(item.total)));
            }, 0);
            setTotal(totalAmount);
          }
          setViewCart(dataList);
        });
      // setViewCart(dataList);
      // setTotal([total, cgst, sgst, basePrice]);
      toast.success("Product Removed From the Cart !", {
        duration: 3000,
        position: "top-right",
      });
      setShowModal("");
      calcTotal(dataList);
    }
  };

  const checkout = () => {
    if (total <= verifyAmount) {
      if (getCustomerId()) {
        history("/CheckoutPage");
      } else {
        dispatch({ type: "MODAL", payload: "login" });
      }
    } else {
      toast.error(`The Purchase Amount Is Shouldn't Be Greater Than ${verifyAmount}`, {
        position: "top-right",
        duration: 3000
      })
    };
  };

  const getPriceCheck = async () => {

    let filter = 'sales_threshold';
    let appConfigResData = await ECommerce(filter);
    let appConfigthresholdValue = JSON.parse(appConfigResData.response.moduleField);
    let saleThresholdValue = 0;
    Object.entries(appConfigthresholdValue).forEach((entry) => {
      if (entry[0] === "sales_threshold_amount") {
        saleThresholdValue = entry[1];
      }
    });
    setVerifyAmount(saleThresholdValue);
  }

  return (
    <StyledDiv>
      <Toaster position="top-right" />
      {banner && banner.length > 0 ? (
        <img
          src={banner}
          alt="Jewellery Product Cart Items"
          className="w-100"
        />
      ) : (
        <Skeleton tw="w-full" style={{ height: "200px" }} />
      )}
      <div className="container-xl " tw="py-5 sm:py-20">
        {viewCart.length > 0 ? (
          <div className="row">
            <div className="col-lg-8">
              {viewCart.map((list) => (
                <>
                  <div className="mb-4">
                    <div className="container-xl">
                      <div className="row p-sm-4 border" tw="rounded-t-lg">
                        <div className="col-sm-3 p-0 p-auto">
                          <img
                            // src={
                            //   list.productImageUrlList &&
                            //   list.productImageUrlList[0]
                            //     ? list.productImageUrlList[0]
                            //     : Noimg
                            // }
                            src={
                              list.images.includes("@#@") &&
                                list.images !== "@#@"
                                ? list.images.split("@#@")[0]
                                : Noimg
                            }
                            alt="AMR Sumangalee Jewellers-product"
                            className="m-auto"
                            tw="sm:w-full w-40"
                          />
                        </div>
                        <div className="col-sm-9">
                          <div className="ms-sm-4">
                            <h4 tw="text-xl mb-3 sm:mt-0 mt-5 block">
                              {list.title}
                            </h4>
                            <div className="d-flex justify-content-between col-md-8">
                              <div tw="w-48">
                                <p
                                  tw="text-base flex font-medium"
                                  className="ptSans justify-content-between"
                                >
                                  Product Type<span>:</span>
                                </p>
                              </div>
                              <p
                                tw="text-base flex"
                                className="ptSans px-4 w-100"
                              >
                                {list.metalType}{" "}
                              </p>
                            </div>
                            <div className="d-flex justify-content-between col-md-8">
                              <p
                                tw="text-base flex font-medium w-48"
                                className="ptSans justify-content-between"
                              >
                                Product Code<span>:</span>
                              </p>
                              <p tw="text-base" className="ptSans px-4 w-100">
                                {list.skv}{" "}
                              </p>
                            </div>

                            {/* <div className="d-flex  col-md-8 justify-content-between">
                            <p
                              tw="text-base flex font-medium w-48"
                              className="ptSans justify-content-between"
                            >
                              Qty<span>:</span>
                            </p>
                            <p
                              tw="text-base flex"
                              className="ptSans px-4 w-100"
                            >
                              1
                            </p>
                          </div> */}
                            <div className="d-flex  col-md-8 justify-content-between">
                              <p
                                tw="text-base flex font-medium w-48"
                                className="ptSans justify-content-between"
                              >
                                <span tw="text-base inline  tracking-widest ">
                                  {" "}
                                  Total{" "}
                                </span>{" "}
                                <span>:</span>
                              </p>
                              <h3
                                tw="text-base flex text-xl text-orange-600"
                                className=" px-4 w-100"
                              >
                                ₹ {Math.trunc(list.total)}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div tw="bg-gray-300 text-gray-700 mx-3 rounded-b-lg p-2 px-5 font-semibold cursor-pointer text-right  tracking-wide text-sm">
                      {list?.statusName?.toLowerCase() === "sold" && (
                        <div>
                          {" "}
                          <span style={{ color: "red" }}>
                            * This Item is Sold Please Remove this Item
                          </span>
                        </div>
                      )}
                      <span onClick={() => setShowModal(list.skv)}>
                        <i className="bi bi-trash3-fill mx-2"></i> Remove
                      </span>
                    </div>
                  </div>
                </>
              ))}
              <div className="col-10 col-sm-5 col-lg-3 py-3">
                <div
                  type="button"
                  tw="border text-white bg-custom-100 border-custom-100 tracking-wide hover:text-white hover:bg-custom-100  font-medium text-center rounded-md   text-sm"
                  onClick={() => history("/productList")}
                  className="d-flex align-items-center justify-content-evenly p-2"
                >
                  <i tw="text-3xl"></i> Continue Shopping
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div
                className="price-detail-section orderItem-box rounded"
                tw="border border-custom-100 border-dashed"
              >
                <p className="text-success mb-2 fw-bold">
                  {/* Order Summary ( {viewCart.length} Items ) */}
                  Order Summary ({viewCart.length}){" "}
                  {`${viewCart.length === 1 ? "Item" : "Items"}`}
                </p>

                {/* <div className="row">
                  <div className="label-col col-sm-7 col">
                    <p>Sub Total</p>
                  </div>
                  <div className="price-col col-sm-5 col">
                    <p>
                      <span>₹ </span>
                      <span>{total[3]}</span>
                    </p>
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="label-col col-sm-7 col">
                    <p>CGST </p>
                  </div>
                  <div className="price-col col-sm-5 col">
                    <p className="">
                      <span>₹ </span>
                      <span>{total[1]}</span>
                    </p>
                  </div>
                </div> */}
                {/* <div className="row">
                  <div className="label-col col-sm-7 col">
                    <p>SGST</p>
                  </div>
                  <div className="price-col col-sm-5 col">
                    <p className="">
                      <span>₹ </span>
                      <span>{total[2]}</span>
                    </p>
                  </div>
                </div> */}
                <div className="row">
                  <div className="label-col col-sm-7 col ">
                    <div>
                      <span className="you-pay fw-bold">Total payable</span>
                      <div>
                        <span className="inc-tax" tw="text-xs">
                          {/* <small className="inc-tax" tw="text-xs"> */}
                          (Incl of all taxes.)
                          {/* </small> */}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="price-col col-sm-5 col mt-2">
                    <span className="you-pay-amt fw-bold text-uppercase">
                      <span>₹ </span>
                      <span>{Math.trunc(total).toString()}</span>
                    </span>
                  </div>
                </div>
              </div>
              {!validation && (
                <div>
                  {" "}
                  <span style={{ color: "red" }}>
                    * One of the item is Sold on your cart. Please Remove &
                    Proceed
                  </span>
                </div>
              )}
              {validation && (
                <button
                  className="px-5 py-3 my-2  hoverEffect rounded"
                  tw="font-semibold w-full tracking-wide"
                  onClick={checkout}
                >
                  Proceed To Checkout
                </button>
              )}
            </div>
          </div>
        ) : (
          <div className="w-100 py-3">
            <div className="cart-wrapper">
              <div className="cart-empty-wrapper text-center">
                <div className="col-md-12 empty-wrapper">
                  <img
                    className="trash-icon m-auto"
                    tw=" w-3/5 sm:w-1/4"
                    alt="cart empty img"
                    src="data:image/svg+xml;base64,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"
                  />
                  <h3 tw="text-custom-100 uppercase py-5 font-extrabold">
                    Your Cart is Empty
                  </h3>
                  <button
                    className="primary-btn cart-btns false hoverEffect py-3 px-5 rounded"
                    onClick={() => history("/ProductList")}
                  >
                    Continue Shopping
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {showModal && (
        <>
          <RemoveCart
            setShowModal={() => setShowModal("")}
            showModal={showModal}
            removeItemFromCart={removeItemFromCart}
          />{" "}
          <div tw="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      )}
    </StyledDiv>
  );
};
